import { render, staticRenderFns } from "./FollowUpStudentsView.vue?vue&type=template&id=783ade4a&scoped=true&"
import script from "./FollowUpStudentsView.vue?vue&type=script&lang=js&"
export * from "./FollowUpStudentsView.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpStudentsView.vue?vue&type=style&index=0&id=783ade4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783ade4a",
  null
  
)

export default component.exports